import { useEffect } from 'react';

import type { ButtonImpression } from 'src/shared/telemetry';
import { buttonImpression } from 'src/shared/telemetry';

/**
 * Sends a buttonImpression event when the calling component renders the first
 * time.
 */
export const useButtonImpression = (trackingData: ButtonImpression) => {
  useEffect(() => {
    buttonImpression(trackingData);
    // Intentionally empty dependency array as this effect should only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
